var map = {
	"./Graph_MAP.png": 156,
	"./Graph_Ote.png": 157,
	"./Graph_Para-Priv.png": 158,
	"./Graph_UP.png": 159,
	"./logo.svg": 160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 155
// module chunks = 1